import axios from 'axios'

export const getData = (url, config = {}) => {
    return new Promise((resolve, reject) => {
        axios.get(url, config).then(response => {
            resolve(response?.data || response)
        }).catch(error => {
            // handle error code here
            reject(error)
        })
    })
}

export const postData = (url, data) => {
    return new Promise((resolve, reject) => {
        axios.post(url, data).then(response => {
            resolve(response?.data || response)
        }).catch(error => {
            // handle error code here
            reject(error)
        })
    })
}